import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

type RepublishChoice = 'republish' | 'keep';

interface WarrantyRepublishDialogProps extends RequiredTestIdProps {
  onSubmit: (republishAds: boolean) => Promise<void>;
}

export function WarrantyRepublishDialog(props: WarrantyRepublishDialogProps) {
  /**
   * openDialog renders this content as a snapshot outside the form's React tree,
   * so the mutation's isLoading flag cannot reach it - the pending choice is
   * tracked here to keep both buttons in sync with the running request.
   */
  const [pendingChoice, setPendingChoice] = useState<RepublishChoice | null>(null);

  const submitChoice = async (choice: RepublishChoice) => {
    setPendingChoice(choice);
    await props.onSubmit(choice === 'republish');
    setPendingChoice(null);
  };

  const isSubmitting = isNotNil(pendingChoice);

  return (
    <VStack spacing={4}>
      <Text>{i18n.t('entity.warranty.republishDialog.description')}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={() => submitChoice('keep')}
          isLoading={pendingChoice === 'keep'}
          isDisabled={isSubmitting}
          title={i18n.t('entity.warranty.republishDialog.reject')}
          data-testid={suffixTestId('reject', props)}
        />
        <Button
          variant="primary"
          onClick={() => submitChoice('republish')}
          isLoading={pendingChoice === 'republish'}
          isDisabled={isSubmitting}
          title={i18n.t('entity.warranty.republishDialog.confirm')}
          data-testid={suffixTestId('confirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
